import React from "react";
import { useMarket } from "../context/MarketContext";

const fmt = (v, cur) => {
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: cur, maximumFractionDigits: 0 }).format(v);
  } catch {
    return `${Math.round(v).toLocaleString("en-US")} ${cur}`;
  }
};

// Primary = user market currency (real FX). Secondary = ORIGINAL price/currency,
// always visible. If no real rate exists, the converted value is marked
// unavailable — never fabricated. Original marketplace price is never overwritten.
export const PriceTag = ({ originalPrice, originalCurrency, size = "lg", testid, priceIsOriginal = true }) => {
  const { market, toMarket } = useMarket();

  if (originalPrice == null) {
    return (
      <span className="text-sm text-muted-foreground italic"
        data-testid={testid ? `${testid}-unavailable` : undefined}>Price unavailable</span>
    );
  }

  const marketVal = toMarket(Number(originalPrice), originalCurrency);
  const sameCur = originalCurrency === market.currency;
  const big = size === "lg" ? "font-mono text-2xl" : size === "md" ? "font-mono text-xl" : "font-mono text-base";
  const origStr = `${Number(originalPrice).toLocaleString("en-US")} ${originalCurrency || ""}`.trim();

  return (
    <div data-testid={testid}>
      {marketVal != null ? (
        <div className={`${big} text-foreground`} data-testid={testid ? `${testid}-primary` : undefined}>
          {fmt(marketVal, market.currency)}
        </div>
      ) : (
        <div className="text-sm text-amber-700" data-testid={testid ? `${testid}-noconv` : undefined}>
          Converted price unavailable
        </div>
      )}
      <div className="text-xs text-muted-foreground" data-testid={testid ? `${testid}-original` : undefined}>
        {priceIsOriginal ? `${origStr} · original listing price` : `≈ ${origStr} · price reported by aggregator (EUR)`}
      </div>
    </div>
  );
};
